export function PayRunsSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/pay-runs.svg'"></ng-include>`
    }
}
            